import { useApplyEdition } from '@/pages/Apply/components/use-apply-edition';
/**
 * Inline event label used as the small pre-title on apply/invite pages:
 *   Platanus Hack 26: Bogotá
 *
 * "26" uses font-logo (Oxanium); ": Bogotá" uses font-title
 * (Thermochrome). Inherits color and size from its parent (typically muted-
 * foreground, sm).
 */
export function EventLabel() {
  const { eventCity } = useApplyEdition();
  return (
    <>
      Platanus Hack <span className="font-logo tracking-tight">[26]</span>
      <span className="font-title uppercase tracking-normal">: {eventCity}</span>
    </>
  );
}
